export default {
  passwordModal: {
    title: 'Enregistrer un mot de passe',
    text: 'Enregistrer un mot de passe finaliser la création de votre compte et pouvoir revenir sur cette page',
    email: 'Email',
    password: {
      label: 'Mot de passe',
      empty: 'Veuillez renseigner un mot de passe',
      lengthCondition: 'Le mot de passe doit faire au minimum 10 caractères',
      caseCondition: 'Le mot de passe doit contenir une minuscule et une majuscule',
      specialCondition: 'Le mot de passe doit contenir un caractères spécial (caractères ou chiffres, lettres)',
    },
    passwordConfirmation: {
      label: 'Confirmer le mot de passe',
      empty: 'Veuillez confirmer le mot de passe',
      notEqual: 'Le mot de passe et sa confirmation ne sont pas égaux',
    },
    rules: {
      title: 'Règles pour le mot de passe, il doit contenir :',
      lengthCondition: 'Au minimum 10 caractères',
      caseCondition: 'Une minuscule et une majuscule',
      specialCondition: 'Un caractères spécial (caractères ou chiffres/lettres)',
    },
  },
};
